import { Dialog, Transition } from "@headlessui/react";
import { useState, Fragment, useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import Select from "react-select";
import {formBtn1,formBtn2,inputClass,labelClass,} from "../Utils/CustomClasses";
import Error from "../Error/Error";
import { validateEmail, validatePhoneNumber } from "../Utils/Validation";
import { AddCompanyAPI, UpdateComapnyAPI } from "../../API/Api";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import ButtonLoader from "../Loader/ButtonLoader";
import {customStyles,onMenuClose,onMenuOpen,} from "../Utils/CommonFuntion";
import { leadFieldOptions, leadStatusOptions, colorOptions } from "../Utils/StaticData";
import { IconEdit } from "@tabler/icons-react";

export default function AddCompany({ edit, filterRecords, rowdata }) {
  const {register,handleSubmit,control,watch,reset,formState: { errors },setValue,} = useForm();
  const userDetails = useSelector((state) => state?.login?.userDetails);
  const [isOpen, setIsOpen] = useState(false);
  const [loader, setloader] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [ariaFocusMessage, setAriaFocusMessage] = useState("");


  const colors = colorOptions.map((color) => ({
    value: color.value,
    label: (
      <div className="flex items-center gap-2">
        <span
          className="w-3 h-3 rounded-full"
          style={{ backgroundColor: `var(${color.value})` }}
        ></span>
        {color.name}
      </div>
    ),
  }));

  useEffect(() => {
    if (edit == true) {
      reset({
        companyName: rowdata?.companyName,
        companyEmail: rowdata?.companyEmail,
        companyPhone: rowdata?.companyPhone,
        addressLine1: rowdata?.addressLine1,
        addressLine2: rowdata?.addressLine2,
        noOfEmployee: rowdata?.noOfEmployee,
        noOfRole: rowdata?.noOfRole,
        city: rowdata?.city,
        country: rowdata?.country,
        parentCompany: rowdata?.parentCompany,
        pincode: rowdata?.pincode,
        state: rowdata?.state,
        breakTimeLimit: {
          lunch: rowdata?.breakTimeLimit?.lunch || "",
          tea: rowdata?.breakTimeLimit?.tea || "",
          loo: rowdata?.breakTimeLimit?.loo || "",
          meeting: rowdata?.breakTimeLimit?.meeting || "",
        },
      });

      const selectedColor = colors.find(
        (item) => item.value === rowdata?.color,
      );
      setValue("color", selectedColor || null);

      //  SET MULTI SELECT VALUE
      if (rowdata?.allowedLeadTableFields) {
        const selectedLeadFields = rowdata.allowedLeadTableFields.map(
          (field) => ({
            value: field,
            label: field,
          }),
        );

        setValue("allowedLeadTableFields", selectedLeadFields);
      }
      if (rowdata?.allowedLeadStatus) {
        const selectedLeadStatus = rowdata.allowedLeadStatus.map(
          (status) => ({
            value: status,
            label: status,
          })
        );

        setValue("allowedLeadStatus", selectedLeadStatus);
      }
    }

    if (userDetails?.company?.companyName) {
      setValue("parentCompany", userDetails?.company?.companyName);
    }

  }, [isOpen, edit]);

  const toggle = () => {
    setIsOpen(!isOpen);
    reset();
  };

  const onFocus = ({ focused, isDisabled }) => {
    const msg = `You are currently focused on option ${focused.label}${
      isDisabled ? ", disabled" : ""
    }`;
    setAriaFocusMessage(msg);
    return msg;
  };

  const onSubmit = async (data) => {
    setloader(true);
    const formData = new FormData();
    if (data.companyLogo && data.companyLogo[0]) {
      formData.append("companyLogo", data.companyLogo[0]);
    }
    const updatedPayload = {
      ...data,
      color: data?.color?.value,
      allowedLeadTableFields: data?.allowedLeadTableFields?.map(
        (item) => item.value,
      ),
      allowedLeadStatus: data?.allowedLeadStatus?.map(
      (item) => item.value,
    ),
    };
    if (!edit) {
      updatedPayload.parentCompany = userDetails?.company?._id;
    }

    Object.keys(updatedPayload).forEach((key) => {
      if (key !== "companyLogo" && key !== "breakTimeLimit") {
        if (key === "allowedLeadTableFields") {
          updatedPayload.allowedLeadTableFields?.forEach((field) => {
            formData.append("allowedLeadTableFields", field);
          });
        } else if (key === "allowedLeadStatus") {
          updatedPayload.allowedLeadStatus?.forEach((status) => {
            formData.append("allowedLeadStatus", status);
          });
        } else {
          formData.append(key, updatedPayload[key]);
        }
      }
    });

    if (updatedPayload.breakTimeLimit) {
      Object.keys(updatedPayload.breakTimeLimit).forEach((key) => {
        formData.append(
          `breakTimeLimit[${key}]`,
          updatedPayload.breakTimeLimit[key],
        );
      });
    }

    if (edit) {
      formData.delete("parentCompany");
    }

    try {
      let response;
      if (edit == true) {
        response = await UpdateComapnyAPI(rowdata?._id, formData);
      } else {
        response = await AddCompanyAPI(formData);
      }
      if (response?.status == 201) {
        toggle();
        setloader(false);
        toast.success(response?.data?.message);
        filterRecords();
      } else {
        setloader(false);
        toast.error(response?.error);
      }
    } catch (err) {
      console.log("Error:", err);
      setloader(false);
    }
  };
  return (
    <>
      {edit ? (
        <button
          onClick={toggle}
          className="py-1 rounded-lg flex justify-center w-[24%]"
        >
          <IconEdit stroke={1.5} size={24} color="#000" />
        </button>
      ) : (
        <button onClick={toggle} className={formBtn1}>
          Add Company
        </button>
      )}

      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-[400]" onClose={toggle}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>
          <div className="fixed inset-0 ">
            <div className="flex items-center justify-center min-h-full p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-6xl h-[90vh] flex flex-col overflow-hidden text-left align-middle transition-all transform bg-white rounded-lg shadow-xl">
                  <Dialog.Title
                    as="h2"
                    className="w-full px-3 py-4 text-lg font-semibold leading-6 text-white bg-base-color font-tb"
                  >
                    {edit ? "Edit Company" : "Add Company"}
                  </Dialog.Title>

                  <form
                    onSubmit={handleSubmit(onSubmit)}
                    className="flex flex-col flex-1 min-h-0"
                  >
                    <div className="flex-1 overflow-y-auto min-h-0 p-4 scrollbars">
                      <div className="grid  md:grid-cols-1 lg:grid-cols-3 gap-x-3 gap-y-3 customBox">
                        <div className="pb-4">
                          <label className={labelClass}>
                            Company Name
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="text"
                            className={inputClass}
                            {...register("companyName", { required: true })}
                          />
                          {errors?.companyName && (
                            <Error title="Company Name is Required*" />
                          )}
                        </div>
                        <div className="pb-4">
                          <label className={labelClass}>
                            Parent Company Name
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="text"
                            className={inputClass}
                            disabled
                            {...register("parentCompany", { required: true })}
                          />
                          {errors?.parentCompany && (
                            <Error title="Parent Company Name is Required*" />
                          )}
                        </div>
                        <div className="pb-4">
                          <label className={labelClass}>
                            Address 1<span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="text"
                            className={inputClass}
                            {...register("addressLine1", { required: true })}
                          />
                          {errors?.addressLine1 && (
                            <Error title="Address 1 is Required*" />
                          )}
                        </div>
                        <div className="pb-4">
                          <label className={labelClass}>
                            No of Employees{" "}
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="text"
                            className={inputClass}
                            {...register("noOfEmployee", { required: true })}
                          />
                          {errors?.noOfEmployee && (
                            <Error title="No of Employees is Required*" />
                          )}
                        </div>
                        <div className="pb-4">
                          <label className={labelClass}>
                            No of Roles <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="text"
                            className={inputClass}
                            {...register("noOfRole", { required: true })}
                          />
                          {errors?.noOfRole && (
                            <Error title="No of Roles is Required*" />
                          )}
                        </div>
                        <div className="pb-4">
                          <label className={labelClass}>Address 2</label>
                          <input
                            type="text"
                            className={inputClass}
                            {...register("addressLine2")}
                          />
                        </div>
                        <div className="pb-4">
                          <label className={labelClass}>
                            Color<span style={{ color: "red" }}>*</span>
                          </label>
                          <Controller
                            name="color"
                            control={control}
                            rules={{ required: true }}
                            render={({ field }) => (
                              <Select
                                {...field}
                                styles={customStyles}
                                aria-labelledby="aria-label"
                                ariaLiveMessages={{ onFocus }}
                                inputId="aria-example-input"
                                onMenuOpen={onMenuOpen(setIsMenuOpen)}
                                onMenuClose={onMenuClose(setIsMenuOpen)}
                                options={colors}
                                placeholder="Select Colors"
                                maxMenuHeight={220}
                              />
                            )}
                          />
                          {errors?.color && (
                            <Error title="Color is Required*" />
                          )}
                        </div>
                        <div className="pb-4">
                          <label className={labelClass}>
                            Company Email
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="text"
                            className={inputClass}
                            {...register("companyEmail", {
                              validate: validateEmail,
                            })}
                          />
                          {errors?.companyEmail && (
                            <Error title={errors?.companyEmail?.message} />
                          )}
                        </div>
                        <div className="pb-4">
                          <label className={labelClass}>
                            Phone Number
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="text"
                            className={inputClass}
                            {...register("companyPhone", {
                              validate: validatePhoneNumber,
                            })}
                          />
                          {errors?.companyPhone && (
                            <Error title={errors?.companyPhone?.message} />
                          )}
                        </div>
                        <div className="pb-4">
                          <label className={labelClass}>
                            City<span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="text"
                            className={inputClass}
                            {...register("city", { required: true })}
                          />
                          {errors?.city && <Error title="City is Required" />}
                        </div>
                        <div className="pb-4">
                          <label className={labelClass}>
                            State<span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="text"
                            className={inputClass}
                            {...register("state", { required: true })}
                          />
                          {errors?.state && <Error title="State is Required" />}
                        </div>
                        <div className="pb-4">
                          <label className={labelClass}>
                            Country<span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="text"
                            className={inputClass}
                            {...register("country", { required: true })}
                          />
                          {errors?.country && (
                            <Error title="Country is Required" />
                          )}
                        </div>
                        <div className="pb-4">
                          <label className={labelClass}>
                            Pincode<span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="text"
                            className={inputClass}
                            {...register("pincode", { required: true })}
                          />
                          {errors?.pincode && (
                            <Error title="Pincode is Required" />
                          )}
                        </div>
                        <div className="pb-4">
                          <label className={labelClass}>
                            Lunch Break Time Limit
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="text"
                            className={inputClass}
                            {...register("breakTimeLimit[lunch]", {
                              required: true,
                            })}
                          />
                          {errors?.breakTimeLimit?.lunch && (
                            <Error title="Lunch Break Time Limit is Required" />
                          )}
                        </div>
                        <div className="pb-4">
                          <label className={labelClass}>
                            Tea Break Time Limit
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="text"
                            className={inputClass}
                            {...register("breakTimeLimit[tea]", {
                              required: true,
                            })}
                          />
                          {errors?.breakTimeLimit?.tea && (
                            <Error title="Tea Break Time Limit is Required" />
                          )}
                        </div>
                        <div className="pb-4">
                          <label className={labelClass}>
                            Loo Break Time Limit
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="text"
                            className={inputClass}
                            {...register("breakTimeLimit[loo]", {
                              required: true,
                            })}
                          />
                          {errors?.breakTimeLimit?.loo && (
                            <Error title="Loo Break Time Limit is Required" />
                          )}
                        </div>
                        <div className="pb-4">
                          <label className={labelClass}>
                            Meeting Break Time Limit
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="text"
                            className={inputClass}
                            {...register("breakTimeLimit[meeting]", {
                              required: true,
                            })}
                          />
                          {errors?.breakTimeLimit?.meeting && (
                            <Error title="Meeting Break Time Limit is Required" />
                          )}
                        </div>

                        <div className="pb-4">
                          <label className={labelClass}>
                            Select Lead Fields
                            <span style={{ color: "red" }}>*</span>
                          </label>

                          <Controller
                            name="allowedLeadTableFields"
                            control={control}
                            rules={{ required: true }}
                            render={({ field }) => (
                              <Select
                                {...field}
                                options={leadFieldOptions}
                                isMulti
                                placeholder="Select Lead Fields"
                                styles={customStyles}
                                closeMenuOnSelect={false}
                                maxMenuHeight={220}
                                menuPlacement="auto"
                              />
                            )}
                          />

                          {errors?.allowedLeadTableFields && (
                            <Error title="Lead Fields are Required*" />
                          )}
                        </div>

                        <div className="pb-4">
                          <label className={labelClass}>
                            Select Lead Status
                            <span style={{ color: "red" }}>*</span>
                          </label>

                          <Controller
                            name="allowedLeadStatus"
                            control={control}
                            rules={{ required: true }}
                            render={({ field }) => (
                              <Select
                                {...field}
                                options={leadStatusOptions}
                                isMulti
                                placeholder="Select Lead Status"
                                styles={customStyles}
                                closeMenuOnSelect={false}
                                maxMenuHeight={220}
                                menuPlacement="auto"
                              />
                            )}
                          />

                          {errors?.allowedLeadStatus && (
                            <Error title="Lead Status is Required*" />
                          )}
                        </div>

                        <div className="">
                          <label className={`${labelClass} hover:opacity-70`}>
                            Company Logo
                          </label>
                          <input
                            type="file"
                            id="companyLogo"
                            {...register("companyLogo")}
                          />
                        </div>
                      </div>
                    </div>
                    <footer className="flex justify-end px-4 py-3 space-x-3 bg-white border-t shrink-0">
                      {loader ? (
                        <ButtonLoader />
                      ) : (
                        <button
                          type="submit"
                          className={`${formBtn1} relative px-4 py-2 text-white font-bold rounded-lg flex items-center justify-center`}
                        >
                          <span className="opacity-100">
                            {edit ? "Update" : "Submit"}
                          </span>
                        </button>
                      )}
                      <button
                        type="button"
                        className="w-auto lg:px-8 px-4 transition-colors font-tb tracking-wide duration-200 py-2.5 overflow-hidden text-base font-semibold text-center text-base-color border-2 border-base-color rounded-lg hover:text-white hover:bg-[var(--bg-base-color)] capitalize"
                        onClick={toggle}
                      >
                        Close
                      </button>
                    </footer>
                  </form>
                  
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
